import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Preview({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-2 -2 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M27.8236 18.4976887c-2.2213333 7.1254717-9.854 11.1181132-17.04733333 8.9177358C3.58226667 25.2150472-.4484 17.6543868 1.7736 10.52891509c2.22133333-7.12547169 9.854-11.1181132 17.0473333-8.91773584 7.1933334 2.20037735 11.224 9.76037735 9.0026667 16.88650945zM23.8509333 24.5971321L34.7016 35.345434M8.16633333 14.7863019H21.7796667M14.973 8.04450943V21.5287547" />
      </g>
    </svg>
  )
}

Preview.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
